<template>
  <v-row class="text--primary">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Últimas compras
        </v-subheader>
        <v-divider/>
        <px-ultimas-compras-produto-table :produto="itemAprovacao.produto"/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import UltimasComprasProdutoTable
  from '@/modules/compra/compra-produtos/UltimasComprasProdutoTable.vue';

export default {
  props: {
    itemAprovacao: {
      type: Object,
      required: true,
    },
  },
  components: {
    pxUltimasComprasProdutoTable: UltimasComprasProdutoTable,
  },
};
</script>
